<template>
  <div class="game-play">
    <loading-state :state="state"></loading-state>
    <div v-if="state.isLoaded()">
      <game-head :preview="preview"></game-head>
      <router-link v-if="preview.my_team" class="clean link small my-teams" :to="{ name: 'FGGameTeams', params:{contestKey: contestKey, gameKey: gameKey}}">My Teams</router-link>
      <div class="selection-box">
        <div class="my-team" v-if="selector">
          <div class="selection-state">
            <div :class="{'card inv': showRuleDetails}">
              <h2 v-if="showRuleDetails">Rule</h2>
              <div class="selection-state-preview">
                <div v-if="selector.teamState.fullfillResult">
                  <span class="good" v-if="selector.teamState.fullfillResult.pass">
                    <span>✌️ </span>
                    <span>Good to go!</span>
                  </span>
                  <span class="error" v-else>
                    <span>&#9758; </span>
                    <span>{{selector.teamState.fullfillResult.msg}}</span>
                  </span>
                  <span v-if="!showRuleDetails"><button @click="showRuleDetails=true" class="clean small link">View Rule</button></span>
                  <span v-else><button @click="showRuleDetails=false" class="clean small link">Hide Rule</button></span>
                </div>
              </div>
              <div class="rule-detail" v-if="showRuleDetails">
                <div>
                  <ul>
                    <li
                      class="rule-item"
                      v-for="(ff, i) in selector.teamState.ruleManager.fulfillments"
                      :key="i"
                      :class="{'status-error': !ff.isFulfilled(selector.teamState).pass}"
                    >
                      <div class="status-icon">
                        <span class="show-for-good">☑</span>
                        <span class="show-for-error">☒</span>
                      </div>
                      <div class="rule-state">
                        <div>
                          <span class="label">{{ff.label}}</span>
                          <span class="fulfillment">
                            <span class="fulfilled">{{ff.fulfilled(selector.teamState, ' / ')}}</span>
                            <span class="fulfillment-label" v-if="ff.hasFulfillmentLabel">{{ff.fulfillmentLabel}}</span>
                          </span>
                        </div>
                        <div class="show-for-error error-msg">
                          <span>{{ff.isFulfilled(selector.teamState).msg}}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="my-players" v-if="selector.teamState.playerKeys.length">
            <div class="card inv">
              <h2>Your team</h2>
              <div class="main-actions" v-if="selector.teamState.fullfillResult.pass">
                <loading-state :state="stateSave"></loading-state>
                <div v-if="participated">
                  <div>👌You are participating with this team</div>
                  <div><router-link :to="{ name: 'FGGame', params: {gameKey}}" class="clean small link">View Game</router-link></div>
                </div>
                <!-- <div v-if="selector.userTeam && selector.userTeam.key">
                  Edit doesnt work now 🤒
                </div> -->
              </div>
              <button
                :disabled="!selector.teamState.fullfillResult.pass"
                v-if="!stateSave.isLoading() && !participated"
                @click="save()"
                class="clean call-to-action">
                <span v-if="selector.userTeam && selector.userTeam.key">Save</span>
                <span v-else>Participate</span>
              </button>
              <button
                :disabled="!selector.teamState.fullfillResult.pass"
                v-if="!stateSave.isLoading() && !participated && selector.userTeam && selector.userTeam.key"
                @click="deleteTeam(selector.userTeam.key)"
                class="clean call-to-action left-space">
                <span>Delete</span>
              </button>
              <button class="clean call-to-action" 
                v-if="!stateSave.isLoading() && !participated && selector.userTeam && selector.userTeam.key" 
                @click="removeParticipation(selector.userTeam.key)">Remove Participation</button>
              <div class="player-items">
                <div
                  class="item"
                  v-for="playerKey in selector.teamState.playerKeys"
                  :key="playerKey"
                >
                  <div class="line for-name">
                    <div class="credits">{{credits.players[playerKey].credits}}</div>
                    <div class="name">{{credits.players[playerKey].player.jersey_name}}</div>
                  </div>
                  <div class="line">
                    <div class="team">{{credits.players[playerKey].team.code}}</div>
                    <div class="role">{{credits.players[playerKey].primary_role}}</div>
                  </div>
                  <div class="line actions">
                    <span class="action">
                      <button
                        class="clean small remove"
                        @click="removePlayer(playerKey)">Remove</button>
                    </span>
                    <span
                      class="action powerup"
                      v-for="(name, i) in selector.rule.boost_names"
                      :key="i"
                      >
                      <button
                        class="clean small remove"
                        v-if="i === selector.teamState.playersState[playerKey].boostIndex"
                        @click="removeBoost(playerKey)">Remove {{name}}</button>
                      <button
                        class="clean small"
                        v-else
                        @click="addBoost(i, playerKey)">{{name}}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="all-players inv card" v-if="credits">
          <h2>Select your players</h2>
          <div class="filter">
            <button
              class="clean small"
              v-for="filter in filters"
              :key="filter.uid"
              :class="[filter.kind, (activeFilter.uid == filter.uid)? 'active': '']"
              :style="{color: filter.color}"
              @click="activeFilter=filter"
              >{{filter.name}}</button>
          </div>
          <div class="player-items">
            <div
              class="item"
              v-for="playerKey in playersToShow"
              :key="playerKey"
            >
              <div class="line for-name">
                <div
                  class="credits"
                  :style="{xcolor: creditsColors[credits.players[playerKey].credits]}">{{credits.players[playerKey].credits}}</div>
                <div class="name">{{credits.players[playerKey].player.jersey_name}}</div>
              </div>
              <div class="line left-space bottom-space">
                <div
                  class="team"
                  :style="{color: teamColors[credits.players[playerKey].team.key]}">{{credits.players[playerKey].team.code}}</div>
                <div
                  class="role"
                  :style="{color: roleColors[credits.players[playerKey].primary_role]}">{{credits.players[playerKey].primary_role}}</div>
              </div>
              <div class="line left-space">
                <div class="reason" v-if="!selector.selectable(playerKey)">
                  {{selector.selectableReason(playerKey)}}
                </div>
                <div class="action" v-else>
                  <button class="clean small" @click="addPlayer(playerKey)">Select</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { DataState } from '@/state'
import { GamePreview } from '@/models/fantasygame/core'
import { FantasyTeamSelector } from '@/models/fantasygame/team'
import * as Colors from '@/models/fantasygame/colors'
import GameHead from '@/components/fantasygame/GameHead'

class FilterableItem {
  constructor (kind, name, key, color) {
    this.uid = `${kind}|${key}`
    this.kind = kind
    this.name = name
    this.key = key
    this.color = color
  }
}

export default {
  components: {
    GameHead
  },

  data () {
    return {
      contestKey: this.$route.params.contestKey,
      gameKey: this.$route.params.gameKey,
      showRuleDetails: true,
      preview: null,
      contest: null,
      credits: null,
      selector: null,
      teamColors: {},
      roleColors: {},
      creditsColors: {},
      activeFilter: null,
      filters: [],
      participated: false,
      state: DataState.newLoading(),
      stateContest: DataState.newLoading(),
      stateCredits: DataState.newLoading(),
      stateSave: DataState.newNotInit()
    }
  },

  watch: {
    '$route' (to, from) {
      if (to.params.gameKey !== from.params.gameKey) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },

  mounted () {
    this.onViewOpenned()
  },

  computed: {
    playersToShow () {
      if (!this.activeFilter || this.activeFilter.kind === 'all') {
        return this.credits.player_keys
      }

      const filteredPlayers = []

      if (this.activeFilter.kind === 'team') {
        this.credits.player_keys.forEach((key) => {
          if (this.credits.players[key].team.key === this.activeFilter.key) {
            filteredPlayers.push(key)
          }
        })
      }

      if (this.activeFilter.kind === 'role') {
        this.credits.player_keys.forEach((key) => {
          if (this.credits.players[key].primary_role === this.activeFilter.key) {
            filteredPlayers.push(key)
          }
        })
      }

      return filteredPlayers
    }
  },

  methods: {
    onViewOpenned () {
      this.contestKey = this.$route.params.contestKey
      this.gameKey = this.$route.params.gameKey

      GamePreview.fetch(this.gameKey).then((resp) => {
        this.preview = resp
        return this.preview.fetchContest()
      }).then((resp) => {
        this.contest = resp
        this.stateContest.changeToLoaded()
        return this.preview.fetchCredits()
      }).then((resp) => {
        this.selector = new FantasyTeamSelector(
          this.contest.rule, this.preview.game, resp)
        if (this.preview.my_team) {
          this.selector.updateUserTeam(this.preview.my_team)
        }
        this.credits = resp
        this.stateCredits.changeToLoaded()
        this.state.changeToLoaded()
        this.dataReady()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    prepareToReopen () {
      this.showRuleDetails = false
      this.preview = null
      this.contest = null
      this.credits = null
      this.selector = null
      this.teamColors = {}
      this.roleColors = {}
      this.creditsColors = {}
      this.filters = []
      this.activeFilter = {}
      this.participated = false
      this.state = DataState.newLoading()
      this.stateContest = DataState.newLoading()
      this.stateCredits = DataState.newLoading()
    },

    addPlayer (key) {
      console.log('Adding Player', key)
      this.selector.addPlayer(key)
    },

    addBoost (index, key) {
      this.selector.addBoostPlayer(index, key)
    },

    removePlayer (key) {
      this.selector.removePlayer(key)
    },

    removeBoost (key) {
      this.selector.removePlayerBoost(key)
    },

    save () {
      this.stateSave.changeToLoading()
      this.selector.save().then((resp) => {
        this.participated = true
        this.stateSave.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.stateSave.changeToError(error)
      })
    },
    removeParticipation (key) {
      this.stateSave.changeToLoading()
      this.selector.removeParticipation(key).then((resp) => {
        this.onViewOpenned()
        this.$notify({
          title: 'Success',
          message: resp.msg,
          type: 'success'
        })
        this.stateSave.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.stateSave.changeToError(error)
      })
    },
    deleteTeam (key) {
      this.stateSave.changeToLoading()
      this.selector.deleteTeam(key).then((resp) => {
        this.$notify({
          title: 'Success',
          message: 'Team deleted sucessfully',
          type: 'success'
        })
        this.onViewOpenned()
        this.stateSave.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.stateSave.changeToError(error)
      })
    },

    refreshView () {

    },

    dataReady () {
      const creditsColorsScale = ['#33a433', 'orange']
      // const creditsColorsScale = ['black', '#1f5460']
      const roleColorsScale = [
        '#ec4bad', '#995eee', '#269191'
      ]
      this.teamColors = Colors.colorsFromList(this.credits.team_keys)
      this.roleColors = Colors.colorsFromObjectProp('primary_role', this.credits.players, roleColorsScale)
      this.creditsColors = Colors.colorsFromObjectProp('credits', this.credits.players, creditsColorsScale)

      const allFilter = new FilterableItem('all', 'Everyone', 'all', '')
      this.filters = [
        allFilter
      ]
      this.activeFilter = allFilter

      Object.keys(this.teamColors).forEach((key) => {
        const color = this.teamColors[key]
        const name = this.credits.teams[key].code
        this.filters.push(
          new FilterableItem('team', name, key, color)
        )
      })

      Object.keys(this.roleColors).forEach((key) => {
        const color = this.roleColors[key]
        const name = key
        this.filters.push(
          new FilterableItem('role', name, key, color)
        )
      })

      // this.simulate()
    },

    simulate () {
      this.showRuleDetails = true
      // const keys = this.credits.player_keys.slice(0, 3)
      const keys = [
        '1196717922010140673',
        '1180037131628843010',
        '1159405354220654593',
        '1159393692516225025',
        '1095040365943197697',
        '1003621984598364175'
      ]

      if (keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          setTimeout(() => {
            this.addPlayer(keys[i])
            if (i < 2) {
              this.addBoost(i, keys[i])
            }
          }, (i + 1) * 500)
        }
      }
    }
  }
}
</script>
